import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/sms-deliverability")({
    beforeLoad: () => {
        throw redirect({ to: "/developer/sms-deliverability", replace: true });
    },
});
